import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrls: ['./gift-cards.component.scss']
})
export class GiftCardsComponent implements OnInit {

  giftCards: any[] = [];
  modalDelete = false;
  loading: boolean = false;
  giftCardIdToDelete: any;
  activeTab = 'search';

  search(activeTab: string){
    this.activeTab = activeTab;
  }

  result(activeTab: string){
    this.activeTab = activeTab;
  }
  constructor(
    private settingsService: SettingsService,
    public themingService: ThemingService,
    public lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.getGiftCardTypes();
  }

  async getGiftCardTypes() {
    this.loading = true;
    await this.lambdaService
      .getGiftCardTypes(
        this.themingService.shopId)
      .then((data: any) => {
        this.giftCards = data;
      });
    this.loading = false;
  }

  setCreatingGiftCardType(){
    this.settingsService.setCreatingGiftCardType();
  }

  setEditingGiftCardType(giftCardTypeId: string){
    this.settingsService.setEditingGiftCardType(giftCardTypeId);
  }

  deleteGiftCardType(response: number) {
    if (response) {
        this.loading = true;
        this.lambdaService.deleteGiftCardType(this.themingService.shopId, this.giftCardIdToDelete)
            .then((data) => {
                this.getGiftCardTypes();
                $('#deleteGiftCardModal').modal('show');
                this.loading = false;
            })
            .catch((error) => {
                console.error("Error deleting gift card type:", error);
                this.loading = false;
            });
        this.modalDelete = false;
    } else {
        this.modalDelete = false;
        this.loading = false;
    }
  }

  closeModal(){
    $('#deleteGiftCardModal').modal('hide');
  }

}
